module.exports = __webpack_public_path__ + "media/assets/cnn-logo-badge.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/cnn-logo-badge.svg
// module id = 27
// module chunks = 0